import { Component, Input, Output, OnInit, OnDestroy, EventEmitter, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { AppService } from 'src/app/app.service'; // 'src/app/app.service';
import { TabitPayService } from 'src/app/tabit-pay/tabit-pay.service';
import { DialogsService } from 'src/app/_services/dialogs.service';
import { TipDialogComponent } from 'src/app/tabit-pay/_dialogs/tip-dialog/tip-dialog.component';
import * as _ from 'lodash';
declare const $: any;

@Component({
    selector: 'app-tabitpay-checkout-partial',
    templateUrl: './tabitpay-checkout-partial.component.html',
    styleUrls: ['./tabitpay-checkout-partial.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TabitpayCheckoutPartialComponent implements OnInit, OnDestroy {
    @Input() options;
	@Output() onContinue = new EventEmitter<any>();
	@Output() onPayment = new EventEmitter<any>();

	@ViewChild('widgetsContent', { read: ElementRef }) public widgetsContent: ElementRef<any>;

	private orderSubscription: Subscription = null;
	private checkSubscription: Subscription = null;

	splitPaymentOptions: any = [];
	spOption: any;

	$storage: any;
	PD: any;

	site: any = {
		amountText: '',
		amountVal: 0
	};
	gratuity: any;
	partialPayment: any;
	partialPaymentActive: boolean;
	manualPartial: any;
	total: any;
	roundPrecision = 0;
	currencyFormat = '1.0-0';
	menuWidth: number = 300;

	tipBehavior: string = 'A';


	constructor(
		public appService: AppService,
		public tabitPayService: TabitPayService,
		public dialogsService: DialogsService,
		public dialog: MatDialog,
	) {
		let that = this;
		this.$storage = this.tabitPayService.$storage;
		this.PD = this.$storage.order.printData;

		this.gratuity = { type: "x", amount: 0 };
		this.total = this.$storage.order.grandTotal || this.$storage.order.balanceDue;

		let currencyDenom = _.get(this.$storage.rosConfig.currencySettings, 'minimalTipDenomination', 100);
		switch (currencyDenom) {
			case 1:
				this.roundPrecision = 2;
				this.currencyFormat = '1.2-2';
				break;
			case 10:
				this.roundPrecision = 1;
				this.currencyFormat = '1.1-1';
				break;
		}

		// ----------------------------------------------------------------------->

		this.orderSubscription = this.tabitPayService.orderChanged$.subscribe(() => {
			that.updateParams();
		});
		this.checkSubscription = this.tabitPayService.checkChanged$.subscribe(() => {
			that.appService.toastr('MESSAGES.PAY_ORDER_CHANGED', { type: 'info' });
			that.onPayment.emit({});
			return;
		});

		this.initParams();
	}

	balanceDue: number;
	orderTotal: number;
	initParams() {
		let that = this, orderTotal, splitTotal;
		if (this.appService.region == 'US') {
			this.tipBehavior = 'P';
		} else {
			this.tipBehavior = this.$storage.isDelivery || this.$storage.isTA ? 'A' : 'P';
		}


		let check = this.$storage.check;
		if (check) {
			orderTotal = this.$storage.check.$$total;
			splitTotal = check.originalTotalForPayment || orderTotal;
			this.balanceDue = check.$$balanceDue;
		} else {
			orderTotal = this.orderTotal = this.$storage.order.itemsTotal;
			splitTotal = this.$storage.order.originalTotalForPayment;
			this.balanceDue = this.$storage.order.balanceDue;
		}

		let arr = [];
		_.each([1, 2, 3, 4], (val) => {
			let o: any = { split: val, text: val + '', amount: 0 };
			o.amount = _.ceil(splitTotal / val, this.roundPrecision);
			if (val == 1) {
				o.isText = true;
				o.amount = _.round(this.balanceDue, 2);
				o.text = that.appService.translate("order_balance");
			} else {
				o.text = 1 + "/" + val;
				o.disabled = (o.amount + 1) > this.balanceDue;
			}
			o.subText = o.amount;
			arr.push(o);
		});
		this.manualPartial = { isManual: true, text: this.appService.translate("other"), isText: true };
		//arr.push(this.manualPartial);
		this.splitPaymentOptions = arr;

		if (!this.partialPayment) this.setSplitPaymentOption(this.splitPaymentOptions[0]);
	}

	updateTimeout;
	closing: boolean = false;
	paying: boolean = false;
	updateParams() {
		let that = this;
		this.tipBehavior = this.appService.region == 'US' || !this.$storage.isDelivery ? 'P' : 'A';


		window.clearTimeout(this.updateTimeout);
		this.updateTimeout = window.setTimeout(() => {
			if (that.closing) return;

			let balanceDue, orderTotal
			let check = this.$storage.check;
			if (check) {
				orderTotal = check.$$balanceDue;
				this.balanceDue = check.$$balanceDue;
			} else {
				orderTotal = that.orderTotal = that.$storage.order.itemsTotal;
				balanceDue = that.$storage.order.balanceDue;
			}

			let wasBalanceChanged = balanceDue != that.balanceDue;
			that.balanceDue = that.$storage.order.balanceDue;

			if (that.balanceDue === 0) {
				that.appService.animDialog({ title: 'MESSAGES.PAYMENT_ACCEPTED_SUCCESSFULLY', animation: 'check' });
				//that.onPayment.emit(true);
				return
			}

			if (!that.paying && wasBalanceChanged) {
				that.appService.toastr('MESSAGES.PAY_ORDER_CHANGED', { type: 'info' });
			}


			_.each(that.splitPaymentOptions, (pm) => {
				let split = pm.split;
				if (pm.isManual) {
					if (pm == that.partialPayment) {
						pm.amount = Math.min(pm.amount, that.balanceDue);
					}
				} else if (split === 1) {
					pm.amount = that.balanceDue;
				} else {
					pm.amount = Math.ceil(orderTotal / split);
					pm.disabled = pm.amount > (that.balanceDue + 1);
				}
				pm.subText = pm.amount;
			});
			that.setSplitPaymentOption(that.partialPayment, true);

		}, 500);
	}

	//UI  --------------------------------------------------------------------->

	isSizeLG: boolean = false;
	ngOnInit() {
		this.isSizeLG = $(window).height() >= 731;
		window.setTimeout(() => {
			this.menuWidth = $("#pm-select-btn").outerWidth() || 300;
			if (this.widgetsContent) {
				let hElm = this.widgetsContent.nativeElement;
				if (hElm.scrollWidth > hElm.offsetWidth) {
					$(hElm).parent().addClass('has-scroll');
				}
			}
		});
		this.$storage.paymentMode = "partial";
		if (this.options.subMode == 'items') {
			this.payByOffers();
		} else if (this.options.subMode == 'diners') {
			this.payByDiners();
		}
		delete this.options.subMode;
	}

	ngOnDestroy() {
		this.orderSubscription.unsubscribe();
		this.checkSubscription.unsubscribe();
	}

	//START PARTIAL PAYMENT --------------------------------------------------------------------->

	setSplitPaymentOption(spo, silent?) {
		if (spo.split) {
			this.partialPayment = spo;
			this.partialPaymentActive = true;
			this.onPartialPaymentChange();
			this.payByOffersResult = null;
			this.payByDinersResult = null;
		} else if (!silent) {
			this.dialogsService.showKeypadDialog(
				{
					title: 'AMOUNT_TO_PAY',
					currency: this.appService.currency,
					maxVal: this.$storage.enableGratuity ? Math.max(this.balanceDue * 3, 200) : this.balanceDue,
					response: { amount: this.partialPayment.amount, amountText: this.partialPayment.amount + "" },
					enableDecimals: this.appService.regionArgs.enableDecimals
				}
			).then(response => {
				if (response) {
					this.payByOffersResult = null;
					this.payByDinersResult = null;
					this.setOtherPayment(spo, response["amount"]);
				}
			})
		}
	}

	onPartialPaymentChange() {
		if (this.partialPayment.amount > this.$storage.order.balanceDue) {
			this.partialPayment.amount = this.$storage.order.balanceDue;
		}
		if (this.gratuity.type == 'p') {
			this.gratuity.amount = this.tabitPayService.calculateGratuityFromPercentage(this.gratuity.percent, this.partialPayment.amount);
		}
	}

	payByOffersResult: any;
	payByOffers() {
		this.dialogsService.payByOffersDialog({
			$storage: this.$storage,
			balanceDue: this.balanceDue,
			selectedOffers: this.payByOffersResult
		}).then(res => {
			if (_.get(res, 'selectedOffers[0]')) {
				this.payByOffersResult = res.selectedOffers;
				this.setOtherPayment(this.manualPartial, res.amount);
				this.$storage.paymentMode = "byItem";
				//this.submit();
			}
		}).catch(err => { });
	}

	payByDinersResult: any;
	payByDiners() {
		this.dialogsService.payByDinersDialog({
			$storage: this.$storage,
			balanceDue: this.balanceDue,
			payByDinersResult: this.payByDinersResult
		}).then(res => {
			if (res) {
				this.payByDinersResult = res;
				this.setOtherPayment(this.manualPartial, res.amount);
				this.$storage.paymentMode = "byDiner";
				//this.submit();
			}
		}).catch(err => { });
	}

	setOtherPayment(spo, amount) {
		spo.amount = amount;
		let diffAmount = spo.amount - this.balanceDue;
		if (diffAmount > 0) spo.amount = this.balanceDue;

		this.partialPayment = spo;
		this.partialPaymentActive = true;
		this.onPartialPaymentChange();

		if (diffAmount > 0) {
			this.slectedGratuity = 'v';
			this.setValGratuity(diffAmount);
		}
	}


	//START GRATITY ---------------------------------------------------------------------------->

	slectedGratuity;
	setManualGratuity(mode) {
		if (this.slectedGratuity == mode) {
			this.clearGratuity();
			return;;
		}
		let amount = this.gratuity.type == 'm' && this.gratuity.amount || 0;
		let maxVal = this.$storage.order.itemsTotal;
		if (maxVal <= 50) maxVal = 200;

		let args = {
			title: 'GRATUITY_AMOUNT',
			currency: this.appService.currency,
			maxVal: maxVal,
			response: { amount: amount, amountText: amount + "" },
			enableDecimals: this.appService.regionArgs.enableDecimals
		}
		if (mode == 'p') {
			args = {
				...args,
				...{
					title: 'GRATUITY_PERCENT',
					currency: '%',
					maxVal: 200
				}
			}
		}
		this.dialogsService.showKeypadDialog(args).then(response => {
			if (response) {
				let val = response["amount"]
				if (mode == 'p') {
					this.setGratuity('p', val);
				} else {
					this.setValGratuity(val);
				}
				this.slectedGratuity = mode;
			}
		})
	}

	setGratuity(_type, pVal) {
		if (this.slectedGratuity == pVal) {
			this.clearGratuity();
			return;
		}
		this.slectedGratuity = pVal;
		this.gratuity.type = _type;
		this.gratuity.percent = pVal;
		if (_type === 'n') {
			this.gratuity.amount = 0;
		} else if (!isNaN(pVal)) {
			this.gratuity.amount = this.tabitPayService.calculateGratuityFromPercentage(pVal, this.options.isTipMode ? this.orderTotal : this.partialPayment.amount);
		} else {
			delete this.gratuity.percent;
			delete this.gratuity.amount;
		}
	};

	setFixedValGratuity(val) {
		if (this.slectedGratuity == val) {
			this.clearGratuity();
			return;;
		}
		this.slectedGratuity = val;
		const total = this.options.subMode == 'tip' ? this.orderTotal : this.partialPayment.amount;
		let gratuity = this.gratuity;
		gratuity.type = 'mm';

		gratuity.amount = val;
		gratuity.percent = val / total * 100;;
	}

	setValGratuity(val) {
		const total = this.options.isTipMode ? this.orderTotal : this.partialPayment.amount;
		let gratuity = this.gratuity;
		gratuity.type = 'm';
		gratuity.amount = val;
		gratuity.percent = val / total * 100;
	}

	clearGratuity() {
		this.slectedGratuity = null;
		this.gratuity = { type: "x", amount: 0 };
	}

	//SUBMIT PAYMENT ---------------------------------------------------------------------------->

	async submit() {

		if (this.partialPayment.amount != this.$storage.order.balanceDue) {
			this.$storage.order.isPartialPayment = true;
			this.$storage.order.grandTotal = this.partialPayment.amount;
		} else {
			delete this.$storage.order.isPartialPayment;
			this.$storage.order.grandTotal = this.$storage.order.balanceDue;
		};

		//START GRATUITY SAVE
		var total = this.$storage.order.grandTotal;
		if (!this.$storage.enableGratuity) this.gratuity.type = 'c';
		var gratuity = this.gratuity;
		const isTipMode = this.options.isTipMode;
		if (isTipMode && !gratuity.amount) gratuity.type = 'x';

		switch (gratuity.type) {
			case "x":
				if (this.appService.regionArgs.promptOnNoTip === false) {
					gratuity.amount = 0;
					gratuity.percent = 0;
					break;
				}
				this.appService.confirm({
					content: 'MESSAGES.CONTINUE_WITHOUT_GRATUITY',
					confirmText: this.appService.region == 'US' || this.appService.region == 'AU' ? 'yes' : 'CONTINUE_WITHOUT_GRATUITY',
					cancelText: this.appService.region == 'US' || this.appService.region == 'AU' ? 'no' : "back",
					enlargeTextButtons: true
				}).then(res => {
					if (!isTipMode) {
						this.gratuity.type = "c";
						this.submit();
					}
				}).catch(err => { });
				return;
				break;
			case "mm": //fixed amount
				gratuity.percent = gratuity.amount / total * 100
				break;
			case "m"://manual gratuity
				var amount = gratuity.amount;
				if (isNaN(amount) || amount == 0) {
					gratuity.type == 'c';
					gratuity.amount = 0;
					gratuity.percent = 0;
				} else {
					gratuity.percent = gratuity.amount / total * 100
				}
				break;
			case "c":
				gratuity.amount = 0;
				gratuity.percent = 0;
				break;
		}
		this.$storage.order.gratuity = gratuity;
		this.onContinue.emit();
		//this.tabitPayService.fixGratuity();
	}

	// -------------------------------------------------------------------->

	async showTipDialog(args) {
		return new Promise((resolve, reject) => {
			let dialogRef = this.dialog.open(TipDialogComponent, {
				width: "340px",
				maxWidth: '95vw',
				panelClass: 'rounded-dialog',
				backdropClass: 'dialog-backdrop-dark',
				direction: this.appService.direction,
				disableClose: true,
				data: { ...args },
				autoFocus: false
			});
			dialogRef.afterClosed().subscribe(result => {
				if (result) {
					if (result === 'CANCEL') return;
					resolve(result);
				} else {
					resolve(null);
				}
			});
		});
	}

}
